import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import MultipleImagePanel from '../../common/image/MultipleImagePanel';
import ProductDetail from './ProductDetail';
import ProductItem from './ProductItem';
import ProductPanel from './ProductPanel';

function ProductPage({ isActive }) {
  const { openProductDetail, navigationContext } = useNavigationContext();
  const { accountContext } = useAccountContext();
  const [productList, setProductList] = useState([]);
  const [productDetail, setProductDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagesManagerIsOpen, setImagesManagerIsOpen] = useState(false);

  const fetchProductList = async () => {
    await privateFetch('GET', 'dejademain', `/cu/${accountContext.id}/product/`).then((res) => {
      setProductList(res);
    });
  };

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductDetail = async () => {
    await privateFetch(
      'GET',
      'dejademain',
      `/cu/${accountContext.id}/product/${navigationContext.acitveProductId}/`
    ).then((res) => {
      if (res) setProductDetail(res);
    });
  };

  useEffect(() => {
    if (navigationContext.acitveProductId) {
      fetchProductDetail();
    } else setProductDetail(undefined);
  }, [navigationContext]);

  const handleClickProduct = (product) => {
    openProductDetail(product);
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const createProduct = async (productForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'dejademain',
      `/cu/${accountContext.id}/product/`,
      'Le produit a bien été ajouté',
      JSON.stringify(productForm)
    ).then(() => {
      fetchProductList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateProduct = async (productForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'dejademain',
      `/cu/${accountContext.id}/product/${productDetail.id}/`,
      'Le produit a bien été modifié',
      JSON.stringify(productForm)
    ).then(() => {
      fetchProductList();
      setPanelIsOpen(false);
      fetchProductDetail(productDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProduct = async (product) => {
    await privateFetch(
      'DELETE',
      'dejademain',
      `/cu/${accountContext.id}/product/${product.id}/`,
      'Le produit a bien été supprimé'
    ).then(() => {
      fetchProductList();
      setProductDetail(undefined);
    });
  };

  const newProductAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un produit',
    icon: 'pi-plus'
  };

  const goBackProductAction = {
    onClick: handleClickProduct,
    label: 'Retour à la liste'
  };

  const updateProductImages = async (images) => {
    await privateFetch(
      'PUT',
      'dejademain',
      `/cu/${accountContext.id}/product/${productDetail.id}/images/`,
      'Les images du produit ont bien été modifiées',
      JSON.stringify({
        images: images.map((image) => image.id)
      })
    ).then(() => {
      fetchProductDetail();
      setImagesManagerIsOpen(false);
      setLoading(false);
    });
  };

  const itemTemplate = (product) => (
    <ProductItem product={product} handleClickProduct={() => handleClickProduct(product)} />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Produits"
        labelAction={handleClickProduct}
        action={productDetail ? goBackProductAction : newProductAction}
        detail={productDetail}>
        {!productDetail ? (
          <DataView value={productList} itemTemplate={itemTemplate} className="pb-20" />
        ) : (
          <ProductDetail
            product={productDetail}
            handleUpdateProduct={handleOpenManager}
            handleUpdateImages={() => setImagesManagerIsOpen(true)}
            handleDelete={handleDeleteProduct}
          />
        )}

        <ProductPanel
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          product={productDetail}
          onCreate={createProduct}
          onUpdate={updateProduct}
          loading={loading}
        />

        <MultipleImagePanel
          loading={loading}
          isOpen={imagesManagerIsOpen}
          onClose={() => {
            setImagesManagerIsOpen(false);
          }}
          images={productDetail?.images}
          onValidate={updateProductImages}
        />
      </PageWrapper>
    </div>
  );
}

export default ProductPage;
